module.exports = __webpack_public_path__ + "img/anchor.3c6cfce7.png";